import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amende-detail',
  templateUrl: './amende-detail.component.html',
  styleUrls: ['./amende-detail.component.scss']
})
export class AmendeDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
